import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { Minus, MinusDisabled, Plus, PlusDisabled } from "../../iconRef/ingredientPageIcons";
import { TextPrimaryBold } from "../typography";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { setServingSize } from "../../app/recipePage/recipePage.slice";


const ServingSize = ({ maxServing, minServing } : { maxServing: number, minServing: number }) => {
  const servingSize = useAppSelector((state) => state.recipePage.servingSize)
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ display: 'flex', gap: 2, justifyContent: "space-between" }}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="body5">Serving Size</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', backgroundColor: 'white', alignItems: 'center', borderRadius: '10px', gap: 1, px: 1, py: '4px' }}>
                        {servingSize === minServing ?
                            <Box sx={{ m: '13px 8px 13px 8px', borderRadius: '5px 0 0 5px', display: 'flex', alignItems: 'center' }}>
                                <MinusDisabled />
                            </Box> :
                            <Box sx={{ p: '13px 8px 13px 8px', borderRadius: '5px 0 0 5px', display: 'flex', alignItems: 'center' }} onClick={() => dispatch(setServingSize(servingSize - 1))}>
                                <Minus />
                            </Box>
                        }
                        <Box sx={{ display: 'flex', alignItems: 'center' }}><TextPrimaryBold text={servingSize.toString()} /></Box>
                        {servingSize === maxServing ?
                            <Box sx={{ m: '5px 8px 5px 8px', borderRadius: '0 5px 5px 0' }}>
                                <PlusDisabled />
                            </Box> :
                            <Box sx={{ p: '5px 8px 5px 8px', borderRadius: '0 5px 5px 0' }} onClick={() => dispatch(setServingSize(servingSize + 1))} >
                                <Plus />
                            </Box>
                        }
                    </Box>
                </Box>
  )
}

export default ServingSize;